import React from "react";
import "./index.scss";

function Advantage({advantageList,advantageName}) {
  return (
    <div className="advantage" 
      style={advantageName.back ? { background: advantageName.back } : null}>
      <div className="edition_solution">
        <div className="edition_solution_title">
          <div>{advantageName.name}</div>
          <span>{advantageName.dil}</span>
        </div>
      </div>
      <ul className="advantage_con">
        {advantageList.map((item, index) => {
          return (
            <li key={index}>
              <div className="advantage_img">
                <img src={item.imgUrl} />
              </div>
              <div className="advantage_name">{item.name}</div>
              <div className="advantage_detail">{item.details}</div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default Advantage;
